"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneNumberForm = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactInputMask = _interopRequireDefault(require("react-input-mask"));
var _core = require("@material-ui/core");
var _Translated = _interopRequireDefault(require("../Translated"));
var _AlertMessage = _interopRequireDefault(require("../AlertMessage"));
var _response = require("../../utils/response");
var _libPhoneNumber = require("../../utils/libPhoneNumber");
var _PhoneCountryCodeSelect = require("../PhoneCountryCodeSelect");
var _hooks = require("../../hooks");
var _countryCodes = require("../../utils/countryCodes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const getMaskByCountryIndex = index => {
  return _countryCodes.countryCodes[index] && _countryCodes.countryCodes[index].mask !== undefined ? _countryCodes.countryCodes[index].mask : null;
};
const PhoneNumberForm = _ref => {
  let {
    children,
    onSubmit,
    onCancel,
    extraText,
    requestError,
    countryCodeProps,
    maxWidth = '100%',
    requestInProgress,
    phone: passedPhone,
    error: passedError,
    optional = false,
    submitButtonProps = {},
    buttonsContainerProps = {},
    countryCode: passedCountryCode,
    cancelButtonText = /*#__PURE__*/_react.default.createElement(_Translated.default, {
      id: "back"
    }),
    submitButtonText = /*#__PURE__*/_react.default.createElement(_Translated.default, {
      id: "next"
    })
  } = _ref;
  const {
    dialCode
  } = (0, _hooks.useConfig)();
  const [error, setError] = (0, _react.useState)(null);
  const [phone, setPhone] = (0, _react.useState)(passedPhone ? String(passedPhone) : '');
  const [countryIndex, setCountryIndex] = (0, _react.useState)(passedCountryCode ? (0, _countryCodes.getCountryIndexByCode)(passedCountryCode) : (0, _countryCodes.getCountryIndexByCode)(dialCode));
  const [mask, setMask] = (0, _react.useState)(getMaskByCountryIndex(countryIndex));
  const isoCountryCode = _countryCodes.countryCodes[countryIndex] && _countryCodes.countryCodes[countryIndex].isoCountryCode !== undefined ? _countryCodes.countryCodes[countryIndex].isoCountryCode : null;
  const countryCode = _countryCodes.countryCodes[countryIndex] && _countryCodes.countryCodes[countryIndex].phoneCode;
  const truePhone = String(phone && phone.match(/\d+/g) && phone.match(/\d+/g).join('')) || String(phone);
  const getIsError = () => {
    return !!error || !!passedError;
  };
  const getErrorText = () => {
    return error || passedError || '';
  };
  const getIsPhoneValid = () => {
    const isPhoneEmpty = truePhone.trim() === '';
    if (optional && isPhoneEmpty) {
      return true;
    }
    if (isPhoneEmpty) {
      setError(/*#__PURE__*/_react.default.createElement(_Translated.default, {
        id: "phone_number_is_required"
      }));
      return false;
    }
    const isPhoneValid = (0, _libPhoneNumber.isValidPhoneNumber)(`${countryCode}${truePhone}`, isoCountryCode);
    if (!isPhoneValid) {
      setError(/*#__PURE__*/_react.default.createElement(_Translated.default, {
        id: "phone_number_is_invalid"
      }));
      return false;
    }
    return true;
  };
  const onCountryCodeChange = e => {
    setError(null);
    const newCountryIndex = e.target.value;
    setCountryIndex(newCountryIndex);
    const newMask = getMaskByCountryIndex(newCountryIndex);
    setMask(newMask);
  };
  const onPhoneChange = e => {
    setError(null);
    setPhone(e.target.value);
  };
  const onFormSubmit = e => {
    e.preventDefault();
    setError(null);
    if (!getIsPhoneValid()) {
      return;
    }
    let phoneNumber;
    try {
      const {
        nationalNumber
      } = (0, _libPhoneNumber.parsePhoneNumber)(`+${countryCode}${truePhone}`);
      phoneNumber = nationalNumber;
    } catch {
      phoneNumber = phone;
    }
    onSubmit({
      phone: phoneNumber,
      countryCode
    });
  };
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    display: "flex",
    component: "form",
    maxWidth: maxWidth,
    flexDirection: "column",
    onSubmit: onFormSubmit
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    mb: 1
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    paragraph: true,
    variant: "h5",
    component: "h4"
  }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
    id: "phone_number"
  })), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    color: "textSecondary"
  }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
    id: "phone_number_description"
  }), extraText && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "\xA0", extraText))), requestError && /*#__PURE__*/_react.default.createElement(_core.Box, null, /*#__PURE__*/_react.default.createElement(_AlertMessage.default, {
    text: (0, _response.getErrorMessage)(requestError)
  })), /*#__PURE__*/_react.default.createElement(_core.Box, {
    mt: 2,
    display: "flex"
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    mr: 1,
    flex: "20%"
  }, /*#__PURE__*/_react.default.createElement(_PhoneCountryCodeSelect.PhoneCountryCodeSelect, _extends({
    value: countryIndex,
    countryCodes: _countryCodes.countryCodes,
    disabled: requestInProgress,
    onChange: onCountryCodeChange
  }, countryCodeProps))), /*#__PURE__*/_react.default.createElement(_core.Box, {
    flex: "80%",
    ml: 1
  }, mask ? /*#__PURE__*/_react.default.createElement(_reactInputMask.default, {
    mask: mask,
    value: phone,
    onChange: onPhoneChange,
    onBlur: getIsPhoneValid,
    disabled: requestInProgress,
    maskPlaceholder: null,
    beforeMaskedStateChange: state => {
      const {
        dynamicMask
      } = _countryCodes.countryCodes[countryIndex];
      if (state.currentState && dynamicMask) {
        if (state.currentState.selection?.start === 0) {
          return state.nextState;
        }
        const newMask = dynamicMask(state.currentState.selection.start);
        if (newMask !== mask) {
          setMask(newMask);
          return state.currentState;
        }
      }
      return state.nextState;
    }
  }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
    fullWidth: true,
    error: getIsError(),
    helperText: getErrorText(),
    label: /*#__PURE__*/_react.default.createElement(_Translated.default, {
      id: "phone_number"
    }),
    inputProps: {
      'data-testid': 'phone-number-input'
    }
  })) : /*#__PURE__*/_react.default.createElement(_core.TextField, {
    fullWidth: true,
    value: phone,
    onChange: onPhoneChange,
    onBlur: getIsPhoneValid,
    disabled: requestInProgress,
    error: getIsError(),
    helperText: getErrorText(),
    label: /*#__PURE__*/_react.default.createElement(_Translated.default, {
      id: "phone_number"
    }),
    inputProps: {
      'data-testid': 'phone-number-input'
    }
  }))), children, /*#__PURE__*/_react.default.createElement(_core.Box, _extends({
    marginTop: 4,
    display: "flex"
  }, buttonsContainerProps), onCancel && /*#__PURE__*/_react.default.createElement(_core.Button, {
    component: _core.Button,
    onClick: onCancel,
    variant: "contained",
    disabled: requestInProgress,
    "data-testid": "cancel-button"
  }, cancelButtonText), /*#__PURE__*/_react.default.createElement(_core.Button, _extends({
    type: "submit",
    color: "primary",
    variant: "contained",
    disabled: requestInProgress
  }, submitButtonProps, {
    "data-testid": "submit-button"
  }), submitButtonText)));
};
exports.PhoneNumberForm = PhoneNumberForm;